export const VIRTUAL_SCROLL_THRESHOLDS = {
  CAMERA: 10,
  EVENT: 10,
  EDGE: 10,
  SPEAKER: 10,
  PEOPLE: 10,
  BUILDING: 10,
  FLOOR: 10,
  SUBLOCATION: 10,
  LOCATION: 10,
} as const;

export const VIRTUAL_SCROLL_ENABLE_THRESHOLDS = {
  CAMERA: 1,
  EVENT: 1,
  EDGE: 1,
  SPEAKER: 1,
  PEOPLE: 1,
  BUILDING: 1,
  FLOOR: 1,
  SUBLOCATION: 1,
  LOCATION: 1,
} as const;


